import React, { Component } from 'react';
import classnames from 'classnames';
import { $ } from 'rype-bootstrap';
import './style.css';

class TopicFilter extends Component {
  constructor() {
    super();

    $.noConflict();
  }

  handleClickMenuItem = (service) => {
    return () => {
      const { category, onClickMenuItem } = this.props;
      onClickMenuItem(category, service);
    };
  }

  renderMenuItem(category, service) {
    const title = service.description;
    return (
      <p
        key={`service_${service.id}`}
        className={classnames(
          'dropdown-item',
          'menu-item',
          'btn-cursor',
          'm-0',
          'px-0',
          {
            selected: service.id === this.props.selectedServiceId
          },
          { [category]: category }
        )}
        onClick={this.handleClickMenuItem(service)}
      >
        {title}
      </p>
    );
  }

  render() {
    const { category, elementID, services } = this.props;

    return (
      <div id={elementID} className="topic-filter">
        {services.map(service => this.renderMenuItem(category, service))}
      </div>
    );
  }
}

export default TopicFilter;



// WEBPACK FOOTER //
// ./src/components/filters/LanguageFilter/TopicFilter/index.js